export const isEqualBy = <T>(
  a: T,
  b: T,
  ...props: ((v: T) => unknown)[]
): boolean => {
  const normalize = <T>(value: T): T | undefined => {
    if (value === '' || value === null) return undefined;
    return value as T;
  };
  return props.every((prop) => normalize(prop(a)) === normalize(prop(b)));
};
